import { MutableRefObject, useCallback } from "react";

// Color of the row when hovered
const ROW_HOVER_COLOR = "#f1f5f9";

/**
 * Syncs the row hover effect between two tables, by setting the background color of the row in both
 * tables. We are using this approach to avoid using react state for performance reasons.
 */
export const useSyncTableRowHover = (
  tableRef1: MutableRefObject<HTMLDivElement | null>,
  tableRef2: MutableRefObject<HTMLDivElement | null>,
) => {
  const onTableHover = useCallback(
    (rowId: string) => {
      tableRef1.current?.style.setProperty(
        `--row-bg-${rowId}`,
        ROW_HOVER_COLOR,
      );
      tableRef2.current?.style.setProperty(
        `--row-bg-${rowId}`,
        ROW_HOVER_COLOR,
      );
    },
    [tableRef1, tableRef2],
  );

  const onTableLeave = useCallback(
    (rowId: string) => {
      tableRef1.current?.style.removeProperty(`--row-bg-${rowId}`);
      tableRef2.current?.style.removeProperty(`--row-bg-${rowId}`);
    },
    [tableRef1, tableRef2],
  );

  return { onTableHover, onTableLeave };
};
